import React, { Component } from "react";
import { Button, Carousel, PageHeader, DropdownButton, MenuItem, Modal, NavItem, Nav, ListGroup, ListGroupItem, Row, Col, Tabs, Tab } from "react-bootstrap";
import { Link, Routes }            from 'react-router-dom'
import RenderLander                from "../../components/utils/RenderLander";
import YouTubeThumbnail            from "../../components/YouTubeThumbnail";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import uniqueId                    from 'lodash/uniqueId';
import { handleGoToURL}            from "../../utils/URL";
import { invokeSetDeleteExercise } from "../../utils/AwsInvoke";
import { createHTMLMarkup }        from "../../utils/HTML";
import { s3PublicGetImage }        from "../../libs/awsLib";
import LoaderButton                from "../../components/LoaderButton";
import { Colors }                  from "../../utils/Colors";
import getMeasureTitle             from "../../utils/Measure";
import ModalAlert                  from "../../components/modal/ModalAlert";
import ModalProgressDetails        from "../../components/modal/ModalProgressDetails";
import ModalShowMemberNotes        from "../../components/modal/ModalShowMemberNotes";
import ClientChart                 from "../../components/chart/ClientChart";
import { FontAwesomeIcon }         from "@fortawesome/react-fontawesome"
import AssessFMS                   from "../../components/report/AssessFMS";
import AssessInBody                from "../../components/report/AssessInBody";
import AssessGirth                 from "../../components/report/AssessGirth";
import AssessBodyComp              from "../../components/report/AssessBodyComp";
import AssessHeartAndBlood         from "../../components/report/AssessHeartAndBlood";
import AssessStrength              from "../../components/report/AssessStrength";
import AssessJointROM              from "../../components/report/AssessJointROM";
import AssessSpinalROM             from "../../components/report/AssessSpinalROM";
import AssessLowerBodyPower        from "../../components/report/AssessLowerBodyPower";
import DatagridTable               from "../../components/dashboard/DatagridTable";
import TableClientProgram          from "../../components/client/TableClientProgram";
import TableClientExerciseHistory  from "../../components/client/TableClientExerciseHistory";
import { XYPlot,
         Crosshair,
         DiscreteColorLegend,
         FlexibleWidthXYPlot,
         HorizontalGridLines,
         LineSeries,
         LineMarkSeries,
         VerticalGridLines,
         XAxis,
         YAxis }        from 'react-vis';
import { Storage } from "aws-amplify";

import { invokeGetNewClientDetail,
         invokeGetAssessmentsListAll,
         invokeGetDocumentsListAll,
         invokeSendEmailNewUserSignup,
         invokeSendEmailResetLoginPassword,
         invokeSetRemoveClientFromTrainerList,
         invokeSuspendMemberAccount,
         invokeGetClientProgramList,
         invokeSetDeleteClient,
         invokeGetClientAssessmentSpinalROMReport,
         invokeGetClientAssessmentStrengthReport,
         invokeGetClientAssessmentLowerBodyPowerReport,
         invokeGetClientAssessmentSpecificReport,
         invokeClientExerciseHistory,
         invokeClientExerciseHistoryDetail,
       } from "../../utils/AwsInvoke";


import '../../css/react-vis/style.css';
import "../../css/form/Form.css";
import "../../css/client/ClientDetail.css";

var pre_survey_data   = [];
var pre_survey_data2  = [];
var post_survey_data  = [];
var post_survey_data2 = [];
const axisProps = {
  tickSizeInner: 0,
  style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

const PRE_WORKOUT_ITEMS = [
    {title: 'Energy Level', color: "#c22a2a", strokeWidth: 14},
    {title: 'Hours of Sleep', color: "#6621c4", strokeWidth: 14 }
];
const POST_WORKOUT_ITEMS = [
    {title: 'Workout Feeling', color: "#4ec22a", strokeWidth: 10},
    {title: 'Training Level',color: "#e19722", strokeWidth: 10}
];

var progress_photo_src = null;

export default class ClientDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            client_id: `${this.props.match.params.id}`,
            showLoadingBar:"none",
            programs: [],
            showClientChart: false,

            modalAlertTitleText: "",
            modalAlertBodyText:  "",
            showModalAlert:      false, // true | false
            showModalProgressDetail: false,
            showModalMemberNotes: false,
            showDeleteConfirmWin: false,
            alertObject:         {},
            alertAction:         "",
            showAssessCharts:    false,
            showExerciseHistory: false,
            showClientPrograms:  false,
            crosshairPreValues:      [], //pre_survey_data
            crosshairPostValues:     [] //post_survey_data
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            if(this.state.client_id != undefined) {

                this.setState({
                    asessInbodyChartData: []
                }, function(){
                    this.getClientData();
                })
            }
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount() {
        ////  RESET ALL SURVEY DATA FOR NEW MEMBER  ////
        pre_survey_data   = [];
        pre_survey_data2  = [];
        post_survey_data  = [];
        post_survey_data2 = [];
        this.setState({
            asessInbodyChartData: []
        })
    }


    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    getClientData = async (client_id) => {
        var client_id   = this.state.client_id;
        var sort_by     = 1
        var search_term = "";
        if(client_id != "undefined") {
                this.setState({
                    loadingData: "Loading member data ... "
                })

                const results  = await invokeGetNewClientDetail(client_id);
                const results2 = await invokeGetClientProgramList(client_id);
                const results3 = await invokeGetAssessmentsListAll(client_id, 100, sort_by, search_term);
                const results4 = await invokeGetDocumentsListAll(client_id, 100, sort_by, search_term);
                var asessInbodyChartData = [];
                if(results && results2 && results3) {
                    var data            = results.data.client_data[0];
                    var data2           = results.data.pre_survey_data;
                    var data3           = results.data.post_survey_data;
                    var data4           = results.data.progress_tracker_data;
                        asessInbodyChartData = results.data.client_inbody_chart_data;
                    var all_programs         = results2.programs;
                    var all_assessments      = results3;
                    var all_documents        = results4;

                    var first_name      = data.first_name;
                    var last_name       = data.last_name;
                    var full_name       = first_name + " " + last_name;
                    var email           = data.email;
                    var phone           = data.phone;
                    var notes           = data.notes;
                    var creator_id      = data.creator_id;
                    var photo_id        = data.photo_id;
                    var suspend         = data.suspend;
                    var profile_img_src = require("../../images/icons/user_profile/user_profile.png");
                    var date            = (new Date(data.date_created)).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
                    var relationship    = null;

                    if(creator_id != null) relationship = "match";

                    if(photo_id != null) {
                        profile_img_src = await s3PublicGetImage("profile-photos", photo_id);
                    }
                    ////  BEGIN: BUILD OUT GRAPH DATA  ////
                    var ctr = 1;
                    var ctr2 = 1;

                    for(var key2 in data2) {
                        var energy_level   = data2[key2].energy_level;
                        var hours_of_sleep = data2[key2].hours_of_sleep;
                        var comments       = data2[key2].comments;
                        var date_created   = data2[key2].date_created;
                        var date           = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric' })

                        pre_survey_data.push({"x": date, "y": energy_level, "comments":comments});
                        pre_survey_data2.push({"x": date, "y": hours_of_sleep, "comments":comments});
                        ctr++;
                    }

                    for(var key3 in data3) {
                        var postworkout_feeling = data3[key3].postworkout_feeling;
                        var level_of_training   = data3[key3].level_of_training;
                        var comments            = data3[key3].comments;
                        var date_created        = data3[key3].date_created;
                        var date                = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric' })

                        post_survey_data.push({"x": date, "y": postworkout_feeling, "comments":comments});
                        post_survey_data2.push({"x": date, "y": level_of_training, "comments":comments});
                        ctr2++;
                    }
                    ////  END: BUILD OUT GRAPH DATA  ////

                    var progress_tracker_data_arr = [];
                    ////  BEGIN: PROGRESS TRACKER DATA  ////
                    for(var key4 in data4) {

                        var progress_title      = data4[key4].title;
                        var progress_comments   = data4[key4].comments;
                        var progress_photo_id   = data4[key4].photo_id;
                        var date_created        = data4[key4].date_created;
                        var date                = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric' })

                        progress_tracker_data_arr.push([progress_title, progress_comments, progress_photo_id, date])
                    }
                    ////  END: PROGRESS TRACKER DATA  ////


                    this.setState({
                        full_name:       full_name,
                        first_name:      first_name,
                        last_name:       last_name,
                        email:           email,
                        phone:           phone,
                        notes:           notes,
                        date_since:      date,
                        suspendMember:   suspend,
                        photo_url:       profile_img_src,
                        relationship:    relationship,
                        isLoading:       false,
                        all_programs:    all_programs,
                        all_assessments: all_assessments,
                        all_documents:   all_documents,
                        asessInbodyChartData: asessInbodyChartData,
                        progress_tracker_data: progress_tracker_data_arr
                    });

                    this.msgDataLoaded();
                } else {
                    this.msgDataLoaded();

                }
        }
    }

    removeClientFromTrainerList = async event => {

        var client_id = this.state.client_id;

        if(client_id != "undefined") {
                this.showLoadingOverlay("Removing member ... ")
                const results = await invokeSetRemoveClientFromTrainerList(client_id);

                if(results)
                    this.props.history.goBack();
                else
                    this.msgDataLoaded();
        }
    }

    onImageURLError = () => {
        //// In case the initial profile photo does not load, load this backup...
        var img_src = require("../../images/icons/user_profile/user_profile.png")
        this.setState({
            photo_url: img_src
        })
    }

    msgDataLoaded = () => {
        this.setState({
            loadingData: "", isLoading: false, showLoadingBar: "none"
        })
    }

    handleProgramClick = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    handleAddMember = event => {
        event.preventDefault();
        this.props.history.push(event.currentTarget.getAttribute("href"));
    }

    showLoadingOverlay (msg) {
        this.setState({
            loadingData: msg,
            showLoadingBar: "inline"
        })
    }

    sendSignupEmail = async event => {
        event.preventDefault();
        this.showLoadingOverlay("An email is being sent to the user ...")
        var email     = this.state.email; //"klusurf@gmail.com";
        var full_name = this.state.full_name; // "Kevin Lu";
        const results = await invokeSendEmailNewUserSignup(email, full_name);

        if(results) {
            this.msgDataLoaded();
            var body_text  = "Sweet, " + full_name + " was sent an email to sign-up for Training Slate.";
            this.setModalAlertProps("Information", body_text, true); // title_text, body_text, show_modal
        } else
            this.msgDataLoaded();
    }

    sendResetPasswordEmail = async event => {
        event.preventDefault();
        this.showLoadingOverlay("An email is being sent to the user ...")
        var email     = this.state.email; //"klusurf@gmail.com";
        var full_name = this.state.full_name; // "Kevin Lu";
        const results = await invokeSendEmailResetLoginPassword(email, full_name);

        if(results) {
            this.msgDataLoaded();
            var body_text  = "Nice, " + full_name + " was sent an email to reset their login password.";
            this.setModalAlertProps("Information", body_text, true); // title_text, body_text, show_modal
        } else
            this.msgDataLoaded();
    }


    async deleteMember () {
        this.setState({
            pageOverlay: "none",
            showDeleteConfirmWin: false,
            loadingData: "Deleting member ... ",
            showLoadingBar: "inline"
        });

        var results = await invokeSetDeleteClient(this.state.clientId);

        if(results.status)
            this.props.history.goBack();
        else
            this.props.history.goBack();
    }

    handleDeleteMember = async (member_id, member_name) => {
        this.setState({
            pageOverlay: "inline",
            showDeleteConfirmWin: true,
            clientId: member_id,
            currentClientName: member_name
        });

        /*
        //// Function below works great in browser but not on a mobile browser;
        //// if you click a member detail, then hit the back btn in the
        //// browser, the onClick handler stops firing and the member no longer
        //// deletes
        Do not use native JS confirmation boxes, they have problems in mobile safari after pressing the back button!
        const confirmed = window.confirm(
            "Are you sure you want to delete this member?"
        );
        if (!confirmed) return;*/
    }

    handleCloseWin = (action) => {
        if(action === "delete") this.deleteMember();
            else this.setState({ pageOverlay: "none", showDeleteConfirmWin: false });
    }

    suspendMember = async event => {
        event.preventDefault();

        var suspend_member = this.state.suspendMember;
        var suspend_label  = "Suspend";
        var suspend        = true;

        if(suspend_member) {
            suspend_label  = "Activat";
            suspend        = false;
        }

        this.showLoadingOverlay(suspend_label + "ing member ...")
        var email     = this.state.email;
        var full_name = this.state.full_name;

        const results = await invokeSuspendMemberAccount(email, suspend);

        if(results) {
            this.msgDataLoaded();
            var body_text  = full_name + "'s account has been "+suspend_label.toLowerCase()+"ed.";

            this.setModalAlertProps("Information", body_text, true); // title_text, body_text, show_modal
            this.getClientData(); // reload client data
        } else
            this.msgDataLoaded();
    }

    onMouseLeavePreWorkout = () =>{
        this.setState({crosshairPreValues: []});
    }

    onMouseLeavePostWorkout = () =>{
        this.setState({crosshairPostValues: []});
    }

    onNearestXPreWorkout = (value, {index}) => {
        var x  = pre_survey_data[index].y;
        var x2 = pre_survey_data[index].x;
        var y  = pre_survey_data2[index].y;//  + " hours";
        var comments = pre_survey_data2[index].comments;

        this.setState({
                        crosshairPreValues: [{x: x2, y: y}], //pre_survey_data.map(d => d[index])
                        crossHairPreX: x,
                        crossHairPreY: y,
                        crossHairPreDate: x2,
                        crossHairPreComments: comments,
                      });
     };

     onNearestXPostWorkout = (value, {index}) => {
         var x  = post_survey_data[index].y;
         var x2 = post_survey_data[index].x;
         var y  = post_survey_data2[index].y;//  + " hours";
         var comments = post_survey_data2[index].comments;

         this.setState({
                         crosshairPostValues: [{x: x2, y: y}], //pre_survey_data.map(d => d[index])
                         crossHairPostX: x,
                         crossHairPostY: y,
                         crossHairPostDate: x2,
                         crossHairPostComments: comments,
                       });
      };

     handleShowProgressDetail = (e, title, notes, photo_id, date) => {

         //this.showLoadingFooter("inherit"); // this adds the overlay before the modal appears
         this.setState({
             showModalProgressDetail: true,
             progressDetailTitle:       title,
             progressDetailNotes:       notes,
             progressDetailPhotoId:     photo_id,
             progressDetailDateCreated: date
         })
     }

     showModalMemberNotes = (e) => {
         this.setState({
             showModalMemberNotes: true
         })
     }

     handleSelect () {
         this.setState({
             showClientChart: true
         })
     }

     handleTabSelect = async (index) => {
         var client_id = this.state.client_id;
         if(index === 3) {
            this.setState({
                showClientPrograms: true
            })
         } else if(index === 4) {
             var show_assess_charts = true

             const resultsInBody         = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentInBodyReport");
             const resultsGirth          = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentGirthReport");
             const resultsBodyComp       = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentBodyCompReport");
             const resultsFMS            = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentFMSReport");
             const resultsStrength       = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentStrengthReport");
             const resultsJointROM       = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentJointROMReport");
             const resultsSpinalROM      = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentSpinalROMReport");
             const resultsLowerBodyPower = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentLowerBodyPowerReport"); //invokeGetClientAssessmentLowerBodyPowerReport(client_id);
             const resultsHeartAndBlood  = await invokeGetClientAssessmentSpecificReport(client_id, "getAssessmentHeartAndBloodReport");

             this.setState({
                 resultsBodyComp:  resultsBodyComp,
                 resultsGirth:     resultsGirth,
                 resultsInBody:    resultsInBody,
                 resultsFMS:       resultsFMS,
                 resultsStrength:  resultsStrength,
                 resultsJointROM:  resultsJointROM,
                 resultsSpinalROM: resultsSpinalROM,
                 resultsLowerBodyPower: resultsLowerBodyPower,
                 resultsHeartAndBlood: resultsHeartAndBlood,
                 showAssessCharts: show_assess_charts
             })

         } else if(index === 2) {
             var show_exercise_history = true;


             this.setState({
                 showExerciseHistory: show_exercise_history
             })
         }
     }

     getAssessCharts () {
         var client_id = this.state.client_id;

         const resultsFMS            = this.state.resultsFMS;
         const resultsInBody         = this.state.resultsInBody;
         const resultsGirth          = this.state.resultsGirth;
         const resultsBodyComp       = this.state.resultsBodyComp;
         const resultsLowerBodyPower = this.state.resultsLowerBodyPower;
         const resultsStrength       = this.state.resultsStrength;
         const resultsSpinalROM      = this.state.resultsSpinalROM;
         const resultsHeartAndBlood  = this.state.resultsHeartAndBlood;
         const resultsJointROM       = this.state.resultsJointROM;

         return (<div>
                     <AssessBodyComp       resultsBodyComp       = {resultsBodyComp} />
                     <AssessInBody         resultsInBody         = {resultsInBody} />
                     <AssessFMS            resultsFMS            = {resultsFMS} />
                     <AssessHeartAndBlood  resultsHeartAndBlood  = {resultsHeartAndBlood} />
                     <AssessLowerBodyPower resultsLowerBodyPower = {resultsLowerBodyPower}/>
                     <AssessStrength       resultsStrength       = {resultsStrength} />
                     <AssessGirth          resultsGirth          = {resultsGirth} />
                     <AssessSpinalROM      resultsSpinalROM      = {resultsSpinalROM} />
                     <AssessJointROM       resultsJointROM       = {resultsJointROM} />
                 </div>)
     }

     getExerciseHistory () {
         var client_id = this.state.client_id;

         return <TableClientExerciseHistory clientId          = {client_id}
                                            isAuthenticated   = {this.props.isAuthenticated} />
     }

     handleViewProgram =(member_url) => {
         this.props.history.push(member_url);
     }

     renderPrograms() {
        var full_name      = this.state.full_name;
        var notes          = this.state.notes;
        var client_id      = this.state.client_id;
        var notesRow;
        var editSpan       = "";
        var tel_notes      = "";
        var suspend_member = this.state.suspendMember;
        var suspend_label  = "Suspend";
        var tmp_notes      = <span style={{color: Colors.default_blue}}>Yes</span>;
        var stripped_html;
        if(suspend_member) suspend_label  = "ACTIVATE";

        if(notes != undefined) {
            // remove all html from text and see if it remains an empty string
            stripped_html = notes.replace(/<[^>]+>/g, '');
        }

        if(notes === "" || notes === null || stripped_html == "") {
            tmp_notes = "None";
        }

        /*if(this.state.relationship === "match")
            notesRow = <div className="clientDetailProfileLabelText">
                            <br/><div dangerouslySetInnerHTML={createHTMLMarkup(notes)} />
                        </div>*/

        if(client_id != undefined) {
                 tel_notes = <div>
                                 { /*}<span className="clientDetailProfileLabelText">Member Since: { this.state.date_since } </span> <p/><br/>*/ }
                                 <div className="clientDetailProfileLabelText">Email: { this.state.email } </div>
                                 <div className="clientDetailProfileLabelText">Phone: { this.state.phone } </div>
                                 <div className="clientDetailProfileLabelText"
                                       style = {{cursor: "pointer"}}
                                       onClick={this.showModalMemberNotes.bind(this)}
                                       > Notes: { tmp_notes }
                                 </div>
                             </div>
             //temp remove since there's no more add/remove friend: 10/14 if(this.state.relationship === "match") // Show Edit/Remove links
                 editSpan = <span style={{position:"relative", top:"9px", left:"50px", color:"#666", fontSize:"20px"}}>
                                <div>
                                    <br/>
                                    <div   style= {{paddingLeft:"3px", paddingRight:"3px",  cursor: "pointer"}}
                                            href= {'/client/edit/' + client_id }
                                            onClick={this.handleAddMember.bind(this)}>
                                            <span className="settingsClientIcons">
                                                <FontAwesomeIcon key={uniqueId()} icon="user" style={{fontSize:26}}/>
                                            </span>
                                            Edit Profile
                                            <div className="settingsClientLabels">Edit the user image, name, email, phone number or personal notes</div>
                                    </div>
                                    <br/>
                                    <div   style= {{paddingLeft:"3px", cursor: "pointer"}}
                                            onClick={this.removeClientFromTrainerList.bind(this)}>
                                            <span className="settingsClientIcons">
                                                <FontAwesomeIcon key={uniqueId()} icon="user-minus" style={{fontSize:26}} />
                                            </span>
                                            Remove From Member List
                                            <div className="settingsClientLabels">After removing a member, you will no longer be able to send the user programs</div>
                                    </div>
                                    <br/>
                                    <div   style= {{paddingLeft:"3px", cursor: "pointer"}}
                                            onClick={this.suspendMember.bind(this)}>
                                            <span className="settingsClientIcons">
                                                <FontAwesomeIcon key={uniqueId()} icon="user-clock" style={{fontSize:26}} />
                                            </span>
                                            {suspend_label} Member
                                            <div className="settingsClientLabels">Suspend a member and all associated programs temporarily</div>
                                    </div>
                                </div>
                                <br/>
                                <div style={{position:"relative", top: "12px", fontSize:"20px", cursor: "pointer", color:"#666"}}>
                                    <div   style= {{paddingLeft:"3px"}}
                                            onClick={this.sendSignupEmail.bind(this)}>
                                            <span className="settingsClientIcons">
                                                <FontAwesomeIcon key={uniqueId()} icon="envelope-open-text" style={{fontSize:26}} />
                                            </span>
                                            Email: Athlete Signup
                                            <div className="settingsClientLabels">Send a user an email to sign-up</div>
                                    </div>
                                    <br/>
                                    <div   style= {{paddingLeft:"3px"}}
                                            onClick={this.sendResetPasswordEmail.bind(this)}>
                                            <span className="settingsClientIcons">
                                                <FontAwesomeIcon key={uniqueId()} icon="user-cog" style={{fontSize:26}} />
                                            </span>
                                            Email: Reset Athlete Password
                                            <div className="settingsClientLabels">If your member forgot his password or just wants to change it, send the user an email </div>
                                    </div>
                                    <br/>
                                    <div   style= {{paddingLeft:"3px"}}
                                            onClick={this.handleDeleteMember.bind(this, client_id, full_name)}>
                                            <span className="settingsClientIcons">
                                                <FontAwesomeIcon key={uniqueId()} icon="user-slash" style={{fontSize:26}} />
                                            </span>
                                            DELETE Member
                                            <div className="settingsClientLabels">Delete the member <i>permanently</i> from your records; be careful and be sure you want to do this</div>
                                    </div>
                                </div>
                                <div> <br/>{ notesRow }</div>
                            </span>

        }
        var data = this.state.progress_tracker_data;
        var pre_survey_exists  = pre_survey_data.length
        var post_survey_exists = post_survey_data.length

        ////  If no data, display a "no-data" block  ////
        var pre_survey_div;
        var post_survey_div;
        if(pre_survey_exists === 0)  pre_survey_div  = <span style={{position:"relative", top: 75, left: "25%", padding: 15, border: "1px solid #ccc"}}>There is currently no survey data.</span>
        if(post_survey_exists === 0) post_survey_div = <span style={{position:"relative", top: 75, left: "25%", padding: 15, border: "1px solid #ddd"}}>There is currently no survey data.</span>
        ////  End: No data

        var pt_data      = this.state.progress_tracker_data;
        var progress_dps = [];

        //if(pt_data != undefined && pt_data.length > 0)
            //progress_dps.push(<FontAwesomeIcon key={uniqueId()} icon="camera-retro" className="progressTimelineIcon"/>);
        var timeline_width = 0;
        for(var key in pt_data) {
            var title    = pt_data[key][0];
            var notes    = pt_data[key][1];
            var photo_id = pt_data[key][2];
            var date     = pt_data[key][3];
            timeline_width = 130 * key;
            progress_dps.push(<span key={uniqueId()} className="progressDPSPoints">
                                    <img key={uniqueId()}
                                         width={25} height={25}
                                         className="progressPhotoDataPoint"
                                         style ={{position:"relative", left:(5 * Number.parseInt(key+1))}}
                                         onClick = {this.handleShowProgressDetail.bind(this, key, title, notes, photo_id, date)}
                                         src     = {require("../../images/utils/progressCircle3.png")} />
                                     <span className="progressDateDataPoint"
                                           style ={{position:"relative", left: 6+ (5 * Number.parseInt(key+1))}}>
                                           {date}
                                     </span>
                              </span>)
        }

        var progress_timeline = <div className="progressTimelineContainer">
                                    <span className="progressTimelineMask">
                                        { progress_dps }
                                        <span className="progressTimeline" style={{display:"inline-block", position:"absolute", top:25, left:60, height:4, width: timeline_width, border:"0px solid #ccc", backgroundColor: "#ccc"}}/>
                                    </span>
                                    <FontAwesomeIcon key={uniqueId()} icon="camera-retro" className="progressTimelineIcon"/>
                                </div>

        var client_chart;
        //if(this.state.showClientChart) {
            client_chart = <div>
                                <ClientChart asessInbodyChartData = {this.state.asessInbodyChartData}/>
                                <br/>
                            </div>
        //}

        var assess_charts    = "";
        var exercise_history = "";
        var client_programs  = "";
        if(this.state.showAssessCharts)
            assess_charts = this.getAssessCharts();

        if(this.state.showExerciseHistory) {
            exercise_history = this.getExerciseHistory();
        }

        if(this.state.showClientPrograms) {

            client_programs = <TableClientProgram clientId   = {client_id}
                                                  clientName = {full_name}
                                                  handleViewProgram = {this.handleViewProgram}
                                                  isAuthenticated   = {this.props.isAuthenticated} />
        }


        return (

              <div className="programs">
                  <PageHeader>
                            { /********** PROFILE NAME *********/ }
                              <span className="row" style={{position:"relative", top:"-47px", display:"block",textAlign:"center",height:"30px"}}>
                                    { /********** PROFILE PHOTO *********/ }
                                    <span className="clientNewProfilePhoto">
                                      <img id="clientDetailProfilePhoto"
                                           src={this.state.photo_url}
                                           onError={this.onImageURLError}
                                           style={{position:"relative", top:"-10px",maxWidth:"250px", maxHeight:"250px"}}
                                       />
                                   </span>
                                   <br/>
                               <div style={{position:"relative", top:"-25px", fontFamily: "UnitedSansRgMd"}}>
                                        { full_name }
                                      <div style={{display:"block",height:"1px"}}>
                                        { tel_notes }
                                      </div>

                                  </div>
                              </span>
                  </PageHeader>

                        <div style={{position:"relative", top:230}}>
                            <Tabs defaultActiveKey={1}
                                  id="uncontrolled-tab"
                                  onSelect={(event) => this.handleTabSelect(event)} >
                                      <Tab eventKey={1} title="DASHBOARD">

                                        <div className="row">
                                            { progress_timeline }
                                            { /*}<span className="progressTrackerHorLine" />*/}
                                        </div>
                                        <div className="row"> &nbsp; </div>
                                        <div className="row"> &nbsp; </div>

                                        <div className="row"> &nbsp; </div>
                                        <div className="row"> &nbsp; </div>

                                        <Row className="grid">
                                                <Col xs={6} sm={6} md={6} lg={6}>
                                                    <span style={{position:"relative", left:-10}}>
                                                            <div style={{fontSize:22, textAlign:"center"}}>
                                                                <FontAwesomeIcon icon="clipboard-list" style={{fontSize: '1.6em', paddingRight: 8 }}/>
                                                                <span style={{position:"relative", top:-4}}>
                                                                    Pre-Workout Data
                                                                </span>
                                                            </div>
                                                            <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>
                                                                    { pre_survey_div }
                                                                    <FlexibleWidthXYPlot height={200}
                                                                                         xType="ordinal"
                                                                                         onMouseLeave={this.onMouseLeavePreWorkout}
                                                                                         onMouseDown={() => {
                                                                                             //this.setState({showModalProgressDetail: true})
                                                                                            /*if (heldValue) {
                                                                                              this.setState({heldValue: false});
                                                                                              return;
                                                                                            }*/
                                                                                            //this.setState({heldValue: crosshairValues});
                                                                                          }}
                                                                                         >
                                                                      <VerticalGridLines />
                                                                      <HorizontalGridLines />
                                                                      <XAxis title="" {...axisProps}
                                                                             tickFormat={String}/>
                                                                      <YAxis title="Hours/Level" {...axisProps}
                                                                             tickFormat={String} />
                                                                      <LineMarkSeries data={pre_survey_data}
                                                                                      size={2.5}
                                                                                      color="#c22a2a"
                                                                                      onNearestX={this.onNearestXPreWorkout}
                                                                      />
                                                                      <LineMarkSeries data={pre_survey_data2} size={2.5} color="#6621c4"/>
                                                                      <Crosshair values={this.state.crosshairPreValues} >
                                                                          <div style={{background: 'black', borderRadius: 5, width: 200, maxWidth: 300, padding: 10}}>
                                                                              <span style={{fontSize:18}}>Pre-Workout</span>
                                                                              <span style={{display: "block",fontSize:16}}>Energy: {this.state.crossHairPreX}</span>
                                                                              <span style={{display: "block",fontSize:16}}>Sleep: {this.state.crossHairPreY}</span>
                                                                              <span style={{display: "block",fontSize:16}}>Date: {this.state.crossHairPreDate}</span>
                                                                              <span style={{display: "block",fontSize:14}}>
                                                                                  {this.state.crossHairPreComments}
                                                                              </span>

                                                                          </div>
                                                                      </Crosshair>{ /* */ }

                                                                    </FlexibleWidthXYPlot>
                                                                    <DiscreteColorLegend items={PRE_WORKOUT_ITEMS}
                                                                                         orientation='horizontal'
                                                                                         style={{position:"relative", top:-7, left:35}}/>
                                                            </span>
                                                     </span>
                                                </Col>
                                                <Col xs={6} sm={6} md={6} lg={6}>
                                                    <span style={{position:"relative", left:-10}}>
                                                            <div style={{fontSize:22, textAlign:"center"}}>
                                                                <FontAwesomeIcon icon="clipboard-check" style={{fontSize: '1.6em', paddingRight: 8 }}/>
                                                                <span style={{position:"relative", top:-4}}>
                                                                    Post-Workout Data
                                                                </span>
                                                            </div>
                                                            <span style={{display:"inline-block",width:"100%"}}>
                                                                     { post_survey_div }
                                                                      <FlexibleWidthXYPlot height={200}
                                                                                           xType="ordinal"
                                                                                           onMouseLeave={this.onMouseLeavePostWorkout} /*yDomain={[0, 100]}*/>
                                                                          <VerticalGridLines />
                                                                          <HorizontalGridLines />
                                                                          <XAxis title=" "  {...axisProps}
                                                                                 tickFormat={String}/>
                                                                          <YAxis title="Level" {...axisProps}
                                                                                 tickFormat={String} />
                                                                          <LineMarkSeries data={post_survey_data}
                                                                                          size={2.5}
                                                                                          color="#4ec22a"
                                                                                          onNearestX={this.onNearestXPostWorkout}/>
                                                                          <LineMarkSeries data={post_survey_data2}
                                                                                          size={2.5}
                                                                                          color="#e19722" />
                                                                          <Crosshair values={this.state.crosshairPostValues} >
                                                                              <div style={{background: 'black', borderRadius: 5, width: 200, maxWidth: 300, padding: 10}}>
                                                                                  <span style={{fontSize:18}}>Post-Workout</span>
                                                                                  <span style={{display: "block",fontSize:16}}>Workout Feeling: {this.state.crossHairPostX}</span>
                                                                                  <span style={{display: "block",fontSize:16}}>Training Level: {this.state.crossHairPostY}</span>
                                                                                  <span style={{display: "block",fontSize:16}}>Date: {this.state.crossHairPostDate}</span>
                                                                                  <span style={{display: "block",fontSize:14}}>
                                                                                      {this.state.crossHairPostComments}
                                                                                  </span>
                                                                              </div>
                                                                          </Crosshair>
                                                                      </FlexibleWidthXYPlot>
                                                                      <DiscreteColorLegend items={POST_WORKOUT_ITEMS}
                                                                                           orientation='horizontal'
                                                                                           style={{position:"relative", top:-7, left:35}}/>
                                                            </span>
                                                    </span>
                                                </Col>
                                        </Row>

                                        <div className="row"> &nbsp; </div>
                                        <div className="row"> &nbsp; </div>

                                        <Row className="grid">
                                              <Col xs={6} sm={6} md={6}
                                                   style={{textAlign:"center", cursor:"pointer", paddingTop: 8, border:"0px solid #000"}}
                                                   onClick={(e) => handleGoToURL(e, this, `/client/list/${this.state.client_id}/&/${full_name}`)}>
                                                   <div style={{position:"relative", left:10}}>
                                                          <div style={{color: Colors.default_blue, fontSize:22}}>
                                                              <span className="glyphicon glyphicon-list-alt " style={{fontSize: '1em', paddingRight: 8 }}/>
                                                              <span style={{position:"relative", top:-2, color: "#000"}}>
                                                                  Programs
                                                               </span>
                                                           </div>
                                                           <div style={{textAlign:"right", padding:0}}>
                                                           <DatagridTable screen = "single_client_all_programs"
                                                                         data   = {this.state.all_programs}
                                                                         height = "250"
                                                                         width  = "100%" />
                                                            </div>
                                                    </div>
                                              </Col>
                                              <Col xs={6} sm={6} md={6}
                                                   style={{textAlign:"center", cursor:"pointer", }}>
                                                   <div style={{position:"relative", left:10}}>
                                                          <div style={{color: Colors.default_blue, fontSize:22}}>
                                                              <FontAwesomeIcon icon="notes-medical" style={{fontSize: '1.6em', paddingRight: 8 }}/>
                                                              <span style={{position:"relative", top:-4, color: "#000"}}
                                                                    onClick={(e) => handleGoToURL(e, this, `/assessment/listAll/${this.state.client_id}/&`)}>
                                                                  Assessments
                                                              </span>
                                                          </div>

                                                          <DatagridTable screen = "single_client_all_assessments"
                                                                         data   = {this.state.all_assessments}
                                                                         height = "250"
                                                                         width  = "100%"
                                                                         onClick={(e) => handleGoToURL(e, this, `/assessment/listAll/${this.state.client_id}/&`)}/>
                                                          { /*}<Tabs defaultActiveKey={1}
                                                                id="uncontrolled-tab-example"
                                                                onSelect={this.handleSelect} >
                                                                    <Tab eventKey={1} title="Grid">
                                                                          <DatagridTable screen = "single_client_all_assessments"
                                                                                         data   = {this.state.all_assessments}
                                                                                         height = "250"
                                                                                         width  = "100%"
                                                                                         onClick={(e) => handleGoToURL(e, this, `/assessment/listAll/${this.state.client_id}/&`)}/>
                                                                    </Tab>
                                                                    <Tab eventKey={2} title="Chart">
                                                                            <div style={{height:220}}>
                                                                                { client_chart }
                                                                            </div>
                                                                    </Tab>
                                                          </Tabs>*/ }
                                                   </div>
                                              </Col>

                                              <div className="row"> &nbsp; </div>


                                            <Col xs={12} sm={12} md={12}
                                                   style={{textAlign:"center", cursor:"pointer", }}
                                                   onClick={(e) => handleGoToURL(e, this, `/document/listAll/${this.state.client_id}/&`)}>
                                                   <div style={{position:"relative", left:10}}>
                                                          <div style={{color: Colors.default_blue, fontSize:22}}>
                                                              <FontAwesomeIcon icon="folder" style={{fontSize: '1.6em', paddingRight: 8 }}/>
                                                              <span style={{position:"relative", top:-4, color: "#000"}}>
                                                                  Documents
                                                              </span>
                                                          </div>
                                                          <DatagridTable screen = "single_client_all_documents"
                                                                         data   = {this.state.all_documents}
                                                                         height = "250"
                                                                         width  = "100%" />
                                                   </div>
                                              </Col>
                                              <br/><br/><br/>
                                          { /*}<Col xs={4} sm={4} md={4}
                                                   style={{textAlign:"center", cursor:"pointer", position: "relative", top: 30, left: 68}}
                                                   onClick={(e) => handleGoToURL(e, this, `/document/listAll/${this.state.client_id}/&`)}>
                                                  <span className="glyphicon glyphicon-folder-open "
                                                        style={{ fontSize: '1.5em' }}
                                                        />
                                                    <span style={{position: "relative", left: 15, fontSize:22}}>Documents</span>
                                              </Col> */ }
                                        </Row>
                                </Tab>
                                <Tab eventKey={2} title="EXERCISE HISTORY" >
                                        { exercise_history }
                                </Tab>
                                <Tab eventKey={3} title="PROGRAMS" >
                                        { client_programs }
                                </Tab>
                                <Tab eventKey={4} title="REPORTS" >
                                        { assess_charts }
                                </Tab>
                                <Tab eventKey={5} title="SETTINGS">
                                        { editSpan }
                                </Tab>
                        </Tabs>
                    </div>

                    <br/><br/><br/><br/><br/><br/><br/><br/>
                    <br/><br/><br/><br/><br/><br/><br/><br/><br/>
              </div>
        );
    }

    render() {
        let closeModalAlert          = () => this.setState({ showModalAlert: false }); //close simple modal window
        let closeModalProgressDetail = () => this.setState({ showModalProgressDetail: false }); //close simple modal window
        let closeModalMemberNotes    = () => this.setState({ showModalMemberNotes: false });

        return (
              <div className="ProgramList">
                {this.props.isAuthenticated ? this.renderPrograms() : <RenderLander /> }

                <FooterLoadingBar text={this.state.loadingData}
                                  showLoadingBar={this.state.showLoadingBar}/>

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
                  <div>
                        <span className="pageOverlay" style={{display:this.state.pageOverlay}}></span>
                        {this.state.showModalMemberNotes ?
                            <ModalShowMemberNotes
                                show              = {this.state.showModalMemberNotes}
                                onHide            = {closeModalMemberNotes}
                                notes             = {this.state.notes}
                                clientName        = {this.state.full_name}
                            />
                        : null}
                        {this.state.showModalProgressDetail ?
                            <ModalProgressDetails
                                show                     = {this.state.showModalProgressDetail}
                                onHide                   = {closeModalProgressDetail}
                                clientName               = {this.state.full_name}
                                title                    = {this.state.progressDetailTitle}
                                notes                    = {this.state.progressDetailNotes}
                                photoId                  = {this.state.progressDetailPhotoId}
                                dateCreated              = {this.state.progressDetailDateCreated}
                                //handleShowProgressDetail = {this.handleShowProgressDetail.bind(this)}
                            />
                        : null}

                        <div>
                              <span className="pageOVerlay" style={{display:this.state.pageOverlay}}></span>
                              <Modal
                                     show={this.state.showDeleteConfirmWin}
                                     onHide={() => this.handleCloseWin("close")}
                                     size            = "lg"
                                     centered        = "true"
                                     aria-labelledby = "contained-modal-title"
                                     className       = "modalBasics"
                                   >
                                     <Modal.Header closeButton>
                                       <Modal.Title id="contained-modal-title">
                                             <FontAwesomeIcon icon="info-circle" className="modalAlertIcon" />
                                             <span className="modalBasicsTitle">
                                                 CONFIRM MEMBER DELETION
                                             </span>
                                       </Modal.Title>
                                     </Modal.Header>
                                     <Modal.Body>
                                         <span className="modalAlertBody">
                                             Are you sure you want to delete <span style={{fontWeight:"bold"}}>{ this.state.currentClientName }</span> PERMANENTLY?
                                         </span>
                                     </Modal.Body>
                                     <Modal.Footer>
                                         <Button className="modalBasicsBtnClose" onClick={() => this.handleCloseWin("close")}>Cancel</Button>
                                         <span className="modalBasicsFooterXPosSpacer"/>
                                         <LoaderButton
                                             bsSize    = "large"
                                             //disabled  = {!this.validateForm()}
                                             //type      = "submit"
                                             btncolor    = { Colors.delete_button_dark_red_bg }
                                             height      = {38}
                                             width       = {125}
                                             isLoading   = {this.state.isLoading}
                                             text        = "Yes, Delete"
                                             loadingText = "" //"Deleting program…"
                                             onClick     = {() => this.handleCloseWin("delete")}
                                         />
                                     </Modal.Footer>
                               </Modal>
                        </div>
                        { /* <Modal
                               show={this.state.showDeleteConfirmWin}
                               onHide={() => this.handleCloseDeleteConfirmWin("close")}
                               aria-labelledby="contained-modal-title"
                             >
                               <Modal.Header closeButton>
                                 <Modal.Title id="contained-modal-title">
                                     Confirm Member Deletion
                                 </Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                   Are you sure you want to delete this member?
                               </Modal.Body>
                               <Modal.Footer>
                                   <Button onClick={() => this.handleCloseDeleteConfirmWin("close")}>Close</Button>
                                   <Button bsStyle="danger" onClick={() => this.handleCloseDeleteConfirmWin("delete")}>Yes, DELETE</Button>
                               </Modal.Footer>
                         </Modal> */ }
                  </div>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/client/ClientDetail.js